import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import fetchData from 'utils/fetchData';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useBigContext } from 'utils/bigContext';
import stringUtilities from 'utils/stringUtilities';

export default function EmployeeToOnboard() {
    const { id } = useParams();
    const [result, setResult] = useState({});
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();
    const { bigContextState } = useBigContext();

    async function GetData() {
        try {
            var pResponse = await fetchData.Post('/api/OnBoardingTrans/Get', {
                id: id,
                showJobPosition: true
            });
            if (pResponse.rows.length == 0)
                await MySwal.fire({
                    title: "Record Not Found",
                    text: "Record Not Found",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes",
                  });
            setResult(pResponse.rows[0]);
            console.log(bigContextState);
        } catch (e) {
            toast.error(e);
        }
    }

    useEffect(() => {
        GetData();
    }, [id]);

    useEffect(() => {

    }, [id, bigContextState]);

    return (
        <div>
            <button
                onClick={() => navigate(-1)}
                className="whitespace-nowrap hover:underline hover:text-blue-800 underline-offset-2"
            >
                Back
            </button>
            <div className="flex items-center gap-2 pt-2">
                <h1 className="font-semibold text-base">
                    Employee: {result?.employeeName}
                </h1>
            </div>
            <div className="flex items-center gap-2 pt-2">
                <h1 className="font-semibold text-base">
                    Job Position: {result?.jobPositionName}
                </h1>
            </div>

            <div className="datagrid" style={{ maxHeight: "calc(100vh - 160px)" }}>
                <table>
                    <thead>
                        <tr>
                            <th>Phase</th>
                            <th>Action</th>
                            <th>Actioned By</th>
                            <th>Actioned Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Phase 1
                            </td>
                            <td>
                                Submit
                            </td>
                            <td>
                                {result.Action01ByName}
                            </td>
                            <td>
                                {stringUtilities.FormatDate(result.Action01ByDate)}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Phase 2
                            </td>
                            <td>
                                Review
                            </td>
                            <td>
                                {result.Action02ByName}
                            </td>
                            <td>
                                {stringUtilities.FormatDate(result.Action02ByDate)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
    )
}
